



















import { Component, Prop, Vue } from "vue-property-decorator";

const MODULOS = [
  [
    1,
    "Teoria de Pitágoras para os Relacionamentos",
    "Você vai descobrir a facilidade e a satisfação de se relacionar consigo mesmo e com as outras pessoas de uma forma leve, autêntica e verdadeira respeitando a liberdade e a vontade de cada um. Além disso, vai aprender técnicas de autoconhecimento e encontrar um caminho essencial para a qualidade de vida emocional, mental, física e espiritual."
  ],
  [
    2,
    "A ciência na Prática",
    "Aqui, é o momento de entender a numerologia pitagórica, a simbologia dos números e como transformar letras em números. Será estudado também a Àrvore da Vida e suas Partes para você entender o ser humano de forma profunda."
  ],
  [
    3,
    "A Jornada até o Destino",
    "Esse é o ápice do treinamento para entender as pessoas. Você descobrir o que é Propósito de Vida, a Jornada da Alma rumo ao propósito, os ciclos da vida e vai aprender como é realizado o cálculo das idades em que ocorrem esses ciclos Formativo, Produtivo e Colheita."
  ],
  [
    4,
    "Os Momentos dos Grandes Desafios da Vida",
    "Um módulo fantástico onde serão estudados profundamente os Desafios da Vida. Neste momento, será ensinado como calcular a idade em que cada ciclo ocorre na vida de todo ser humano: Formativo, Produtivo e o Flow. Serão descritos e analisados todas as opções de tipos de Desafios de Vida e os Gifts (Presentes da vida)."
  ],
  [
    5,
    "Ano Pessoal e Triângulo da Vida",
    "Aqui é um momento muito importante para entender o ser humano por meio do cálculo do ano pessoal, do entendimento da Simbologia dos Anos Pessoais, do famoso Triângulo da Vida, conhecido como o Tripé de Sustentação da Vida e a simbologia dos dois números mais importantes do Mapa da Vida: Seiva x Propósito de Vida. Além disso, você vai descobrir técnicas científicas para potencializar os três números do Triângulo da Vida e qual o número primordial do Triângulo da Vida."
  ],
  [
    6,
    "Dharma e Heranças de Experiências Anteriores",
    "Esse é o módulo que mais ativa a curiosidade dos <strong>decodificadores</strong>. Será ensinado o que é e quando se inicia o Dharma, o número poderoso, além da descrição de todas opções de tipos de Dharmas e da chamada <strong>Bagagem da Mochila</strong>, com a descrição de cada número da bagagem como “nenhum”, “média”, “+ que a média”, “- que a média”"
  ],
  [
    7,
    "Descanso, Elementos, Presente, Fluidez, Desafios Solitários, Repetições",
    "Perto de finalizar o treinamento, o <strong>decodificador</strong> vai aprender tudo sobre o Descanso para a alma, os Elementos da natureza (outro descanso) e vai compreender o equilíbrio, a falta e o excesso dos elementos Terra, Ar, Água e Fogo, além do Presente Divino e do desafio da Fluidez Liberada"
  ],
  [
    8,
    "Código de Linguagem + Habilidades + Expressão + Herança Familiar + Motivação",
    "No ponto final, o <strong>decodificador</strong> vai se qualificar a calcular e descrever cada grupo de pessoas, por meio do Código de Linguagem, das habilidades (potenciais), da manifestação na vida e da herança familiar. A última abordagem será sobre motivação como a chave da satisfação interior."
  ]
];

@Component
export default class extends Vue {
  modulos: Array<Modulo> = [];

  mounted() {
    this.modulos = MODULOS.map(function(modulo) {
      return new Modulo(modulo[0], modulo[1], modulo[2]);
    });
  }
}

class Modulo {
  numero: any;
  subtitulo: any;
  descricao: any;
  constructor(numero: any, subtitulo: any, descricao: any) {
    this.numero = numero;
    this.subtitulo = subtitulo;
    this.descricao = descricao;
  }
}
